<script>
import { Sortable } from '@shopify/draggable';
import FavoriteAction from '../FavoriteAction.vue';
import CollapsibleSection from '../CollapsibleSection.vue';

export default {
    name: 'MyResources',
    components: {
        FavoriteAction,
        CollapsibleSection,
    },
    props: {
        resourcesOrder: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            order: [],
        };
    },
    mounted() {
        this.order = this.resourcesOrder;
        const myResources = new Sortable(this.$refs.draggable, {
            draggable: '.draggableCard',
            handle: '.mediaCard__dragHandle',
            mirror: {
                constrainDimensions: true,
            },
        });

        myResources.on('sortable:stop', ({ newIndex, oldIndex }) => {
            this.order.splice(newIndex, 0, ...this.order.splice(oldIndex, 1));
            this.updateResourcesOrder();
        });
    },
    methods: {
        updateResourcesOrder() {
            axios.post('/api/resource-bookmarks/sort', {
                resources: this.order,
            }).catch(error => {
                console.warn(error);
            });
        },
    },
};
</script>
